import React from 'react'
import PropTypes from 'prop-types'

const ClosableImage = ({ src, onClose }) => {
    return (
        <div className='img-close-btn'>
            <img src={src} />
            <button className='close-btn' onClick={(e) => onClose(e)} >&times;</button>
        </div>
    )
}

ClosableImage.propTypes = {
    src: PropTypes.string.isRequired,
    onClose: PropTypes.func
}

export default ClosableImage


// WEBPACK FOOTER //
// ./src/components/Image/ClosableImage/ClosableImage.js